<template>
	<div>
		<sub-header bizCd="02"/>
		 <div class="sub_visual sub05">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">원격(Zoom) 화상 교육</div>
                    <div class="comment">현장 강의의 생생함을 그대로!<br>강사-수강생 간 실시간 원활한 소통을 통해 현장 강의 이상의 만족감을 드립니다.</div>
                </div>
            </div>
        </div>
		
		<div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <div class="sub_tit">교육과정</div>
                    <div class="con">
                        <div class="txt">지금 가장 뜨겁게 부상중인 원격(화상)교육 선호과정을 확인하세요. </div>
                        <div class="course_list">
                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-advice.png"
                                                alt="취업 컨설팅" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-advice@3x.png"
                                                alt="취업 컨설팅" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">취업 컨설팅</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 공기업 자소서 </li>
                                            <li>・ 대기업 자소서</li>
                                            <li>・ 면접 컨설팅</li>
                                            <li>・ AI 면접 특강</li>
                                            <li>・ 1:1 자소서 랜선 컨설팅</li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ncs.png"
                                                alt="NCS 직무적성" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-ncs@3x.png"
                                                alt="NCS 직무적성" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">NCS 직무적성</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 공기업 NCS</li>
                                            <li>・ 대기업 직무적성검사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil.png"
                                                alt="공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-civil@3x.png"
                                                alt="공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 필수과목 특강</li>
                                            <li>・ 공무원 면접 특강</li>
                                            <li>・ PSAT 특강</li>
                                            <li>・ 합격비법 특강</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/01-icon-license.png"
                                                alt="취업 자격증" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png"
                                                alt="취업 자격증" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">취업 자격증</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 한국사능력검정</li>
                                            <li>・ 컴퓨터활용능력 1,2급</li>
                                            <li>・ 워드프로세서</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public.png"
                                                alt="HRD,전문직무" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public@3x.png"
                                                alt="HRD,전문직무" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">HRD, 전문직무</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 리더십 역량</li>
                                            <li>・ 소통역량 강좌</li>
                                            <li>・ 업무역량 향상 부문</li>
                                            <li>・ 팀워크/조직 활성화</li>
                                            <li>・ 은퇴자 창업</li>
                                            <li>・ 경영 시뮬레이션</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="sub_tit">화상 교육 예시</div>
                    <div class="con">
                        <div class="txt">강사와 수강생 간 실시간 소통으로, 더욱 몰입도 높은 학습이 가능합니다.</div>
                        <div class="img_wrap">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-remote-02.png" alt="화상교육예시"
                                class="pc480hidden" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-remote-02-mo.png" alt="화상교육예시"
                                class="mobile480hidden" />
                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="clearfix">
                        <div class="sub_tit">화상 교육 Flow</div>
                    </div>
                    <div class="con_wide">

                        <!-- flow PC -->
                        <div class="flow_common flow_m_hidden">
                            <div class="f_wrap">
                                <div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-01.png"
                                        alt="고객사" /></div>
                                <div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450"
                                    data-aos-offset="0">
                                    <div class="text">과정 문의, 요구사항 전달</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">과정 관리, 운영 보고</div>
                                </div>
                                <div class="step03 aos-item" data-aos="fade-right" data-aos-delay="600"
                                    data-aos-offset="0">
                                    <div class="step_edu">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                    <div class="step_text">강사 섭외, 교육준비, 교육모니터링</div>
                                </div>
                                <div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750"
                                    data-aos-offset="0">
                                    <div class="text">학습지원</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">강좌 수강, 학습 문의</div>
                                </div>
                                <div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-03.png"
                                        alt="수강생" /></div>
                            </div>
                        </div>

                        <!-- flow Mobile  -->
                        <div class="flow_common flow_pc_hidden">
                            <div class="f_wrap">
                                <div class="wide">
                                    <div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450"
                                        data-aos-offset="0">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                    <div class="step_text">강사 섭외, 교육준비, 교육모니터링</div>
                                </div>
                                <div class="stepper">
                                    <div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300"
                                        data-aos-offset="0">
                                        <div class="flow_mo_left">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow02_2_left.png" />
                                        </div>
                                    </div>
                                    <div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600"
                                        data-aos-offset="0">
                                        <div class="flow_mo_right">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow02_2_right.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
	<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "ZoomEduSell.vue",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
	},
}
</script>

<style scoped>

</style>
